import { ErrorHandler, Injectable, inject } from '@angular/core';
import { ChunkLoadRecoveryService } from './chunk-load-recovery.service';

@Injectable()
export class GlobalErrorHandlerService implements ErrorHandler {
  private readonly chunkLoadRecoveryService = inject(ChunkLoadRecoveryService);

  handleError(error: unknown): void {
    if (this.chunkLoadRecoveryService.handle(error)) {
      return;
    }

    console.error(error);
  }
}
